<template>
  <div class="common-title">
    <img v-lazy-load data-src="~assets/images/courses/titleLine.png" alt="">
    <span class="font-semibold">{{ title }}</span>
  </div>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    }
  },
}

</script>
<style lang="scss" scoped>
.common-title {
  display: flex;
  margin-bottom: 20px;
  align-items: center;

  img {
    height: 22px;
    width: 4px;
    margin-right: 14px;
  }

  span {
    font-size: 30px;
    color: var(--txt-color-lv1);
    line-height: 36px;
  }
}

</style>
